module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-4.72d6c490.jpg";